{
  "unauthorizedRoute": {
    "subtitle": "Ya no tiene autorización para acceder a esta página",
    "title": "No autorizado"
  },
  "pageNotFound": "Página no encontrada",
  "httpStatusCodes": {
    "400": {
      "title": "Error de solicitud incorrecta",
      "subtitle": "Se ha producido un error de solicitud, compruebe sus datos y vuelva a intentarlo.",
      "codes": {
        "INVALID_VALUE_NOT_NULL": "El campo \"{field}\" es obligatorio.",
        "JSON_NOT_VALID": "El contenido no es un formato JSON válido.",
        "SCHEMA_NOT_MATCH": "El contenido no se corresponde con el patrón previsto.",
        "SCHEMA_NOT_MATCH_FIELD": "El contenido no coincide con el esquema previsto; error en la propiedad “{field}”.",
        "CERTIFICATE_RENEWAL_FAILED_NO_DNS_MATCH": "El DNS y el CN no coinciden con la configuración del certificado."
      }
    },
    "409": {
      "title": "Error de conflicto",
      "subtitle": "Se ha producido un error de conflicto, compruebe sus datos y vuelva a intentarlo.",
      "codes": {
        "UNICITY_CONSTRAINT": "El valor del campo \"{field}\" ya está en uso.",
        "UNICITY_CONSTRAINT_FIELD_LOGIN": "El inicio de sesión ya está en uso.",
        "UNICITY_CONSTRAINT_FIELD_EMAIL": "El correo electrónico ya está en uso.",
        "UNICITY_CONSTRAINT_FIELD_NAME_ORGANIZATION": "El nombre de la organización ya está en uso.",
        "UNICITY_CONSTRAINT_FIELD_USER_GROUP": "Ya existe un grupo de usuarios con ese nombre.",
        "UNICITY_CONSTRAINT_FIELD_USER_PROFILE": "Ya existe un perfil con ese nombre."
      }
    },
    "404": {
      "title": "No se ha encontrado",
      "subtitle": "El recurso no está disponible o se eliminó."
    },
    "401": {
      "title": "No conectado",
      "subtitle": "No está conectado."
    },
    "403": {
      "title": "Acceso no autorizado",
      "subtitle": "No tiene las autorizaciones necesarias.",
      "codes": {
        "SECTOR_DEPTH_EXCEEDED": "No se puede exceder la profundidad máxima del sector {maximum_allowed_depth}.",
        "SECTOR_DELETE_FORBIDDEN": "No se puede suprimir el sector porque tiene conectados algunos dispositivos."
      }
    },
    "500": {
      "title": "Se ha producido un error",
      "subtitle": "Vuelva a intentarlo más tarde."
    },
    "405": {
      "title": "No permitido",
      "subtitle": "No se le permite realizar esta acción."
    },
    "408": {
      "title": "No se puede cargar la página",
      "subtitle": "La solicitud tardó mucho en responder."
    }
  },
  "download": {
    "noData": "No hay datos para descargar"
  }
}
